module.exports = __webpack_public_path__ + "media/images/img3-b187199e12852be80e4c0aa604340726.png";